import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import darkTokens from '@volvo-cars/ui-design-tokens/build/web/volvo-dark/tokens.json';
import lightTokens from '@volvo-cars/ui-design-tokens/build/web/volvo/tokens.json';
import { buildTypeScale } from './buildTypeScale';
import { fonts, isUnsupportedFontLocale } from './fonts';
import { breakpoints } from './getBreakpoints';
import { getLogoImages, logoTypes } from './getLogoImages';
import { getTokens } from './getTokens';
import { fontTypes, getTypeScale } from './getTypeScale';
import { legacyColors } from './legacy-colors';

function isRtlLocale(locale) {
  return typeof locale === 'string' && (locale.startsWith('ar') || locale.startsWith('he'));
}

var icons = ['account', 'email', 'search', 'globe', 'facebook', 'twitter', 'youtube', 'linkedin', 'instagram', 'pinterest', 'youku', 'vkontakte', 'wechat', 'weibo'];
export function getTheme(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'light' : _ref$variant,
      locale = _ref.locale,
      direction = _ref.direction;
  var designTokens = variant === 'light' ? lightTokens : darkTokens;
  var tokens = getTokens(designTokens.color, variant);
  var typeScale = getTypeScale(designTokens.color, locale);
  var logoImages = getLogoImages(variant);
  var name = variant === 'light' ? 'volvo' : 'volvo-dark';
  return _objectSpread({
    name: name,
    direction: direction || (isRtlLocale(locale) ? 'rtl' : 'ltr'),
    baselineGrid: 8,
    baselineSubGrid: 4,
    breakpoints: breakpoints,
    colors: legacyColors,
    tokens: tokens,
    icons: icons,
    fonts: isUnsupportedFontLocale(locale) ? [] : fonts,
    fontsPath: 'https://www.volvocars.com/static/shared/fonts/',
    fontTypes: fontTypes,
    logoImages: logoImages,
    logoImagesPath: 'https://www.volvocars.com/static/shared/images/',
    logoTypes: logoTypes,
    iconsPath: 'https://www.volvocars.com/static/shared/icons/v1.1/',
    typeScale: buildTypeScale(typeScale)
  }, designTokens);
}